module.exports = __webpack_public_path__ + "static/media/background.4bd38d59.png";